<template>
    <div>
        <div class="lg:flex lg:justify-between lg:items-center mb-5">
            <h1 class="text-page-header-font-size headline grow">
                {{ ___("Dashboard|Greeting1|content") }} {{ username }}
                {{ ___("Dashboard|Greeting2|content") }}
            </h1>

            <Btn class="mt-2 lg:mt-0 lg:ml-2" v-if="
                this.filteredDataEntryGroup.length > 0" type="button" @onClick="checkIfDataEntryToBeFilled"
                :class="{'filledDataEntry': isEntryFilled}">
                {{ ___("General|Open data entry modal|content") }}
            </Btn>
        </div>

        <div>
            <div
                class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4"
                v-if="KPI"
            >
                <div
                    class="kpi-item p-4 transition-shadow border rounded-lg shadow-sm hover:shadow-lg text-kpi-font-size"
                    v-for="(value, key, index) in KPI"
                    :key="key"
                >
                    <p v-if="index === 0">
                        {{ ___("Dashboard|" + key + "|content") }}
                    </p>
                    <p v-else>
                        <a
                            v-if="
                                key === 'Total Articles In Cart' ||
                                key === 'Articles accepted' ||
                                key === 'Articles pending acceptance'
                            "
                            @click="gotopipeline(key)"
                            class="cursor-pointer text-gray-800"
                        >
                            {{ ___("Dashboard|" + key + "|content") }}
                        </a>
                        <span v-else>{{ key }}</span>
                    </p>
                    <span class="text-lg font-semibold text-center">{{
                        value
                    }}</span>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
                <section
                    class="bg-white shadow p-5 rounded-lg"
                    v-if="isResourcesEnabled && favouriteResource.length > 0"
                >
                    <p class="text-subheader-font-size">
                        {{ ___("Dashboard|Favourite Resource|content") }}
                    </p>
                    <div class="flex flex-wrap">
                        <div
                            v-for="(favourite, f) in favouriteResource"
                            :key="f + 100"
                            class="bg-primary-color text-primary-text-color p-3 border shadow-lg rounded cursor-pointer w-full flex items-center justify-between"
                            :class="
                                favourite.file_name.length < 10
                                    ? 'md:w-2/4	lg:w-1/3 '
                                    : 'md:w-full lg:w-2/3 '
                            "
                        >
                            <a
                                v-if="favourite.file_type == 'video_link'"
                                class="grow-0 hover:underline flex items-center"
                                target="_blank"
                                :href="favourite.video_link"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-6 mr-1 inline-block flex-none"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                    />
                                </svg>
                                <span v-if="favourite.file_name.length < 30">
                                    {{ favourite.file_name }}
                                </span>
                                <span v-else class="line-clamp-2">
                                    {{ favourite.file_name }}
                                </span>
                            </a>
                            <a
                                v-else-if="favourite.file_type == 'image'"
                                class="grow-0 hover:underline flex items-center"
                                target="_blank"
                                :href="`/preview-file/${favourite.image}`"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-6 mr-1 inline-block flex-none"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                </svg>
                                <span v-if="favourite.file_name.length < 30">
                                    {{ favourite.file_name }}
                                </span>
                                <span v-else class="line-clamp-2">
                                    {{ favourite.file_name }}
                                </span>
                            </a>
                            <a
                                v-else-if="favourite.file_type == 'pdf'"
                                class="grow-0 hover:underline flex items-center"
                                target="_blank"
                                :href="`/preview-file/${favourite.attachment}`"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-6 mr-1 inline-block flex-none"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                    />
                                </svg>

                                <span v-if="favourite.file_name.length < 25">
                                    {{ favourite.file_name }}</span
                                >
                                <span v-else class="line-clamp-2">
                                    {{ favourite.file_name }}
                                </span>
                            </a>
                            <a
                                v-else-if="favourite.file_type == 'video'"
                                class="grow-0 hover:underline flex items-center"
                                target="_blank"
                                :href="`/preview-file/${favourite.attachment}`"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-6 mr-1 inline-block flex-none"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                </svg>
                                <span v-if="favourite.file_name.length < 25">
                                    {{ favourite.file_name }}</span
                                >
                                <span v-else class="line-clamp-2">
                                    {{ favourite.file_name }}
                                </span>
                            </a>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="ml-5 h-6 w-6 text-red-800 stroke-primary-text-color flex-none"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                @click="addToFavourite(favourite.id,'resources')"
                            >
                                <path
                                    stroke-width="1"
                                    fill-rule="evenodd"
                                    d="M3.172 5.172a4 4 0 015.656 0L10
                        6.343l1.172-1.171a4 4 0 115.656 5.656L10
                        17.657l-6.828-6.829a4 4 0 010-5.656z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                    </div>
                </section>
                <section
                    v-if="$page.props.userHasForms && isFormsEnabled"
                    class="bg-white shadow p-5 rounded-lg"
                >
                    <p class="text-subheader-font-size">
                        {{ ___("Dashboard|Forms|content") }}
                    </p>
                    <div class="flex flex-wrap">
                        <div
                            class="bg-primary-color text-primary-text-color p-3 border shadow-lg rounded cursor-pointer w-full flex justify-between"
                            :class="
                                form['attributes']['form_name'].length < 10
                                    ? 'md:w-2/4	lg:w-1/3 '
                                    : 'md:w-full lg:w-2/3 '
                            "
                            @click="gotoform(f)"
                            v-for="(form, f) in filteredFormList"
                            :key="f"
                            :value="f"
                        >
                            <button
                                type="button"
                                class="hover:underline focus:outline-none"
                            >
                                {{ form["attributes"]["form_name"] }}
                            </button>
                        </div>
                    </div>
                </section>
                <section
                    class="bg-white shadow p-5 rounded-lg"
                    v-if="
                        $page.props.isHelpdeskEnabled &&
                        $page.props.accountHelpdeskEnabled
                    "
                >
                    <div v-if="$page.props.isHelpdeskPermissionsAllowed">
                        <div
                            class="flex w-full items-center mb-7 justify-between mb-6"
                        >
                            <p class="text-subheader-font-size">
                                {{ ___("SideNav|Helpdesk|content") }}
                            </p>
                            <Btn type="button" @onClick="goToCreateTicket">
                                {{ ___("SideNav|Create Ticket|content") }}
                            </Btn>
                        </div>
                        <table
                            class="w-full text-left mt-3"
                            v-if="weclappTickets.length > 0"
                        >
                            <thead>
                                <tr
                                    class="text-gray-800 border-b border-gray-600"
                                >
                                    <th class="font-normal px-3 pt-0 pb-3">
                                        {{
                                            ___(
                                                "Helpdesk|Ticket Number|content"
                                            )
                                        }}
                                    </th>
                                    <th class="font-normal px-3 pt-0 pb-3">
                                        {{ ___("General|Subject|content") }}
                                    </th>
                                    <th class="font-normal px-3 pt-0 pb-3">
                                        {{ ___("Helpdesk|Discussion|content") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-700 dark:text-gray-100">
                                <tr
                                    v-for="(ticket, t) in weclappTickets"
                                    :key="t"
                                >
                                    <td
                                        class="sm:p-3 py-2 px-1 border-b border-gray-200 dark:border-gray-800"
                                    >
                                        {{ ticket.ticketNumber }}
                                    </td>
                                    <td
                                        class="sm:p-3 py-2 px-1 border-b border-gray-200 dark:border-gray-800 md:table-cell hidden"
                                    >
                                        {{ ticket.subject }}
                                    </td>
                                    <td
                                        class="cursor-pointer"
                                        @click="toggleModal(ticket, 'active')"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            class="inline cursor-pointer h-5 w-5 mr-3"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                            />
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-page-header-font-size" v-else>
                            {{ ___("Helpdesk|Empty|content") }}
                        </p>
                    </div>
                    <div v-else>
                        <p class="text-subheader-font-size">
                            {{ ___("SideNav|Helpdesk|content") }}
                        </p>
                        {{ ___("Dashboard|Weclapp Permission|content") }}
                    </div>
                </section>
                <section
                    class="bg-white shadow p-5 rounded-lg"
                    v-if="isCustomerFileUploadEnabled"
                >
                    <p class="text-subheader-font-size">
                        {{
                            ___(
                                "Dashboard|File upload into customer document|content"
                            )
                        }}
                    </p>
                    <p>
                        {{
                            ___(
                                "Dashboard|Document will be saved on weclapp|content"
                            )
                        }}
                    </p>
                    <div class="flex justify-between">
                        <input
                            class="block mt-3"
                            id="file-upload"
                            type="file"
                            name="filename"
                            ref="myFileInput"
                            @input="handleSingleFileUpload"
                            accept="image/png,image/jpg,image/jpeg,image/gif,video/mp4,video/avi,video/mov,application/pdf,application/exl,application/doc"
                        />
                        <Btn
                            class="mt-3"
                            type="button"
                            name="customerfileupload"
                            @onClick="uploadCustomerDocument"
                            :class="
                                form.fileupload == null
                                    ? 'cursor-not-allowed '
                                    : 'cursor-pointer '
                            "
                            :disabled="form.fileupload == null"
                        >
                            {{ ___("General|Save|content") }}
                        </Btn>
                    </div>
                    <p class="text-red-600 pt-2" v-if="fileUploadErrorMessage">
                        {{ fileUploadErrorMessage }} ({{ fileUploadSize }}
                        MB)
                    </p>

                    <div class="text-red-700 mt-4" v-if="fileError">
                        <p>
                            {{ fileError }}
                        </p>
                    </div>
                </section>

                <section
                    v-if="showExternalLinksOnDashboard.length > 0"
                    class="bg-white shadow p-5 rounded-lg"
                >
                    <p class="text-subheader-font-size">
                        {{ ___("SideNav|More links|content") }}
                    </p>
                    <ul class="list-none">
                        <li
                            v-for="(link, l) in showExternalLinksOnDashboard"
                            :key="l"
                            class="my-px"
                        >
                            <a
                                v-if="link.layout == 'custom_field_link'"
                                class="flex flex-row items-center p-2 rounded-customRadius border-custom border-transparent hover:border-accent-color w-full"
                                :href="link.value"
                                target="_blank"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5 mr-3"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    />
                                </svg>
                                {{ link.attributes.description }}
                            </a>
                            <a
                                v-else-if="link.layout == 'url_link'"
                                class="flex flex-row items-center p-2 rounded-customRadius border-custom border-transparent hover:border-accent-color w-full"
                                :href="link.attributes.url"
                                target="_blank"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5 mr-3"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    />
                                </svg>
                                {{ link.attributes.description }}
                            </a>
                        </li>
                    </ul>
                </section>
            </div>
            <section
                    class="bg-white shadow p-5 rounded-lg mt-5"
                    v-if="isBlogsEnabled && favouriteBlogs.length > 0"
                >
                     <p class="text-subheader-font-size">
                        {{ ___("Dashboard|Favourite blogs|content") }}
                    </p>
                    <article v-for="(blog, i) in favouriteBlogs" :key="i" class="bg-white shadow-2xl rounded-lg mt-2">
                        <div class="flex justify-between">
                            <div class="flex items-start flex-wrap	">
                                <img
                                    v-if="blog.blog_image"
                                    :src="'/storage/' + blog.blog_image"
                                    :alt="blog.blog_title"
                                    class="h-40"
                                />
                                <div class="p-4">
                                    <p class="font-bold text-lg">{{ blog.blog_title }}</p>
                                    <span>{{ formatDate(blog.created_at) }}</span>
                                    <p class="flex flex-wrap my-3" v-if="blog.tags?.length > 0">
                                        <span
                                            class="
                                                tag-pill
                                                flex
                                                items-center
                                                bg-primary-color
                                                text-primary-text-color text-xs
                                                rounded-full
                                                focus:outline-none
                                                p-1
                                                mb-2
                                                mr-2
                                                cursor-pointer
                                            "
                                            v-for="(tag, t) in blog.tags"
                                            :key="t"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                                                />
                                            </svg>
                                            {{ tag }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6 flex-none text-red-800 stroke-red-800 cursor-pointer mr-4 mt-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                @click="addToFavourite(blog.id,'blogs')"
                            >
                                <path
                                    stroke-width="1"
                                    fill-rule="evenodd"
                                    d="M3.172 5.172a4 4 0 015.656 0L10
                        6.343l1.172-1.171a4 4 0 115.656 5.656L10
                        17.657l-6.828-6.829a4 4 0 010-5.656z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                    
                        <div class="p-4 pt-0 md:pt-4" v-html="blog.description"></div>
                    </article>
                   
                </section>
        </div>

        <TicketModal
            v-if="showModal"
            @close="toggleModal"
            @loadComponent="updateModal"
            :ticket="ticket"
            :type="type"
            :userMainAccountName="userMainAccountName"
            :userSubAccountName="userSubAccountName"
            :userEmail="userEmail"
            :userId="userMainId"
            :helpDeskUser="helpDeskUser"
            :ticketPriority="ticketPriority"
            :ticketAttributesOnDetail="ticketAttributesOnDetail"
            :allTicketStatus="allTicketStatus"
            :ticketCategory="ticketCategory"
            :defaultTicketCategory="defaultTicketCategory"
            :fileUploadSize="fileUploadSize"
            :hideTicketSeverity="hideTicketSeverity"
            :ticketReferenceIsEnabled="ticketReferenceIsEnabled"
            view="dashboard"
        />

        <ConfirmationMessage :isAlertShown="isAlertShown" alertType="Success">
            <template v-slot:alert
                >{{ ___("General|Success|content") }}
            </template>
            <template v-slot:body> {{ $page.props.flash }} </template>
        </ConfirmationMessage>

        <ConfirmationMessage
            :isAlertShown="isFileUploadAlertShown"
            :alertType="customerFileUploadStatus"
            class="z-20"
        >
            <template v-if="customerFileUploadStatus == 'Success'" v-slot:alert>
                {{ ___("Dashboard|File upload success alert|content") }}!
            </template>
            <template v-else v-slot:alert>
                {{ ___("Dashboard|File upload error alert|content") }}!
            </template>
            <template v-if="customerFileUploadStatus == 'Success'" v-slot:body>
                {{ ___("Dashboard|File upload success body|content") }}
            </template>
            <template v-else v-slot:body>
                {{ ___("Dashboard|File upload errror body|content") }}
            </template>
        </ConfirmationMessage>

        <Modal v-if="showEntryFlowModal" @close="toggleEntryFlowModal">
            <template v-slot:header>
                <h3 class="text-subheader-font-size font-semibold">
                    {{ ___("General|Data Entry Header|content") }}
                </h3></template
            >

            <template v-slot:body>
                <div v-for="(entry, e) in filteredDataEntryGroup" :key="e">
                    <h4>{{ entry["title"] }}</h4>
                    <div v-html="entry['description']" class="my-3"></div>

                    <div
                        class="mb-2"
                        v-for="(input, i) in entry['dynamic_fields']"
                    >
                        <label class="field-label" for="current_value_field"
                            >{{ input["label"] }}:</label
                        >
                        <input
                            class="field appearance-none border rounded w-full py-3 px-4 pr-8 text-gray-700 leading-tight focus:outline-none"
                            type="text"
                            name="current_value_field"
                            v-model="input['stringValue']"
                        />
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <Btn type="submit" @onClick="savedetails">
                    {{ ___("General|Save Data Entry|content") }}
                </Btn>
            </template>
        </Modal>
    </div>
</template>

<script>
import { FormatDate } from "../../mixin/formatDate";
import Layout from "@/Shared/Layout";
import ConfirmationMessage from "@/Components/ConfirmationMessage";
import Btn from "@/Components/Btn";
import Multiselect from "vue-multiselect";
import TicketModal from "@/Shared/TicketModal";
import { FileUpload } from "../../mixin/fileUpload";
import Modal from "@/Components/Modal";
import axios from "axios";

export default {
    layout: Layout,
    mixins: [FormatDate, FileUpload],
    props: {
        username: String,
        userId: Number,
        isResourcesEnabled: Boolean,
        favouriteResource: Array,
        isFormsEnabled: Boolean,
        filteredFormList: Array,
        isCustomerFileUploadEnabled: Boolean,
        fileUploadSize: Number,
        weclappTickets: Array,
        userMainAccountName: String,
        userSubAccountName: String,
        userEmail: String,
        userMainId: String,
        helpDeskUser: String,
        ticketPriority: Array,
        ticketAttributesOnDetail: Array,
        allTicketStatus: Array,
        ticketCategory: Array,
        defaultTicketCategory: String,
        filteredDataEntryGroup: Array,
        KPI: Object,
        hideTicketSeverity: Boolean,
        ticketReferenceIsEnabled: Boolean,
        isBlogsEnabled: Boolean,
        favouriteBlogs: Array,
    },
    components: {
        ConfirmationMessage,
        Btn,
        Multiselect,
        TicketModal,
        Modal,
    },
    data() {
        return {
            sidebarOpen: true,
            openTab: 1,
            isAlertShown: false,
            showModal: false,
            form: this.$inertia.form({
                fileupload: null,
            }),
            customerFileUploadStatus: "",
            isFileUploadAlertShown: false,
            fileError: "",
            ticket: "",
            showEntryFlowModal: false,
            isEntryFilled: false
        };
    },
    beforeMount() {
        if (
            this.$page.props.directLogin &&
            this.filteredDataEntryGroup.length > 0 &&
            this.$page.props.user["entry_reminder"]
        ) {
            this.toggleEntryFlowModal();
        }
    },
    methods: {
        toggleTabs(tabNumber) {
            this.openTab = tabNumber;
        },
        addToFavourite(resourceId,type) {
            let data = {
                resourceId: resourceId,
                userId: this.userId,
                route:'dashboard',
                type: type
            };
            this.$inertia.post("/addtofavourite", data, {
                onSuccess: () => {
                    return Promise.all([
                        (this.isAlertShown = !this.isAlertShown),
                        setTimeout(() => {
                            this.isAlertShown = !this.isAlertShown;
                        }, 3000),
                    ]);
                },
            });
        },
        goToCreateTicket() {
            this.$inertia.get("/createticket");
        },
        toggleModal(ticket, type) {
            if (this.showModal) {
                this.showModal = !this.showModal;
                return;
            }
            this.$root.$emit("open-loader");
            axios.get("/loadticket/" + ticket.id).then((response) => {
                this.ticket = response.data;
                this.type = type;
                this.showModal = !this.showModal;
                this.$root.$emit("open-loader");
            });
        },
        uploadCustomerDocument() {
            this.form.post("/uploadcustomerdocument", {
                onSuccess: () => {
                    this.customerFileUploadStatus = this.$page.props.flash;
                    return Promise.all([
                        (this.isFileUploadAlertShown =
                            !this.isFileUploadAlertShown),
                        (this.$refs.myFileInput.value = ""),
                        (this.form.fileupload = null),
                        setTimeout(() => {
                            this.isFileUploadAlertShown =
                                !this.isFileUploadAlertShown;
                        }, 6000),
                    ]);
                },
                onError: (errors) => {
                    if (errors.file == "validation.mimes") {
                        this.fileError = this.___(
                            "Helpdesk|File Type is not valid|content"
                        );
                    }
                },
            });
        },
        updateModal(ticketID,callback) {
            axios.get("/loadticket/" + ticketID).then((response) => {
                this.ticket = response.data;
            })
            .finally(() => {
                callback();
            });
        },
        gotoform(f) {
            this.$inertia.get("/gotoform/" + f);
        },
        gotopipeline(propertyName) {
            if (propertyName == "Articles accepted") {
                this.$inertia.get(
                    "/gotopipeline/" + "ORDER_CONFIRMATION_PRINTED"
                );
            } else if (propertyName == "Articles pending acceptance") {
                this.$inertia.get("/gotopipeline/" + "ORDER_ENTRY_IN_PROGRESS");
            } else {
                this.$inertia.get("/gotopipeline");
            }
        },
        toggleEntryFlowModal() {
            this.showEntryFlowModal = !this.showEntryFlowModal;
        },
        savedetails() {
            let data = {
                form: this.filteredDataEntryGroup,
            };
            this.$inertia.post("/saveentrydetails", data, {
                onSuccess: () => {
                    return Promise.all([this.toggleEntryFlowModal()]);
                },
            });
        },
        checkIfDataEntryToBeFilled()
        {
            if(this.$page.props.user["entry_reminder"]){
                this.showEntryFlowModal = true;
            }
            else{
                this.isEntryFilled = true;
            }
        }
    },
    computed: {
        showExternalLinksOnDashboard() {
            let externalLinks = this.$page.props.externalLinks;
            const filteredItems = externalLinks.filter(
                (item) => item.attributes.show_on_dashboard
            );
            return filteredItems;
        },
    },
};
</script>
